import styled from "styled-components";


export const IssuesCardWrapper = styled.div`

.issueCard{
    border: 1px solid #e4e4e4;
    cursor: pointer;
    border-radius: 7px;
    padding: 5%;
    background: white;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    min-width: 220px;
    height: 125px;
    /* align-items: center; */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
}
.revertedCard{
    border: 1px solid #fbc7c7;
    cursor: pointer;
    border-radius: 7px;
    background: #fbc7c7;
    padding: 5%;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    min-width: 220px;
    height: 125px;
    /* align-items: center; */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
}
.issueHeading{
    font-size: 20px;
    font-weight: 600;
}

.tag1{
    position: absolute;
    top: -11px;
    right: 12px;
    background: #57BE27;
    padding: 1% 4%;
    /* height: 22px; */
    /* width: 46px; */
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    border-radius: 5px;
    font-size: 10px;
}

.tag1-alt{
    background: #213861;
    color: white;
    position: absolute;
    top: -11px;
    right: 12px;
   
    padding: 1% 4%;
    /* height: 22px; */
    /* width: 46px; */
    display: flex;
    align-items: center;
    justify-content: center;
   
    border-radius: 5px;
    font-size: 10px;
}
.totalQ{
    font-size: 11px;
    color: gray;
}

.dateAndB{
    display: flex;
    justify-content: space-between;
    align-items: center;
}


.dateAndButton img{
    cursor: pointer;
}

.date{
    font-size: 10px;
    color: gray;
}

`;
